import { render, staticRenderFns } from "./nutrition-step-one.html?vue&type=template&id=4f44fad6&scoped=true&"
import script from "./nutrition-step-one.js?vue&type=script&lang=js&"
export * from "./nutrition-step-one.js?vue&type=script&lang=js&"
import style0 from "./nutrition-step-one.scss?vue&type=style&index=0&id=4f44fad6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f44fad6",
  null
  
)

export default component.exports